// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { PickUpPreferences, ShippingPreferences } from "@conklin/XDL/constants";
import { parseBoolean } from "@conklin/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { useContext } from "react";
import * as React from "react";

export interface OrderDetailsShippingDetailsStyles {
    titleText?: TypographyPresentationProps;
    heading?: TypographyPresentationProps;
    data?: TypographyPresentationProps;
    wrapper?: InjectableCss;
    container?: InjectableCss;
    shippingMethod?: InjectableCss;
}

export const orderDetailsShippingDetailsStyles: OrderDetailsShippingDetailsStyles = {};
const styles = orderDetailsShippingDetailsStyles;

const OrderDetailsShippingDetails = () => {
    const { value: order } = useContext(OrderStateContext);

    if (!order) {
        return null;
    }

    return (
        <StyledWrapper>
            <Typography as="h3" {...styles.heading}>
                {order.fulfillmentMethod === FulfillmentMethod.PickUp ? translate("Pick Up") : translate("Shipping")}
            </Typography>
            <StyledWrapper {...styles.container}>
                <StyledWrapper {...styles.shippingMethod}>
                    {createWidgetElement("OrderDetails/OrderDetailsShippingMethod", { fields: {} })}
                </StyledWrapper>
                <StyledWrapper {...styles.wrapper}>
                    {order.fulfillmentMethod === FulfillmentMethod.PickUp && (
                        <>
                            <Typography {...styles.titleText}>{translate("Pick Up Preference")}</Typography>
                            <Typography {...styles.data}>
                                {parseBoolean((order.properties.pickUpWhenComplete || "false").toLowerCase())
                                    ? translate(PickUpPreferences.PickUpWhenComplete)
                                    : translate(PickUpPreferences.PickUpWhenReady)}
                            </Typography>
                        </>
                    )}

                    {order.fulfillmentMethod === FulfillmentMethod.Ship && (
                        <>
                            <Typography {...styles.titleText}>{translate("Shipping Preference")}</Typography>
                            <Typography {...styles.data}>
                                {parseBoolean((order.properties.shipWhenComplete || "false").toLowerCase())
                                    ? translate(ShippingPreferences.ShipWhenComplete)
                                    : translate(ShippingPreferences.ShipWhenAvailable)}
                            </Typography>
                        </>
                    )}
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsShippingDetails,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
